import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.storage_unit_movements;

// Axios instance with auth interceptor (token managed automatically)
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
}));

// Cached API wrapper - 2m TTL for historical movement data
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'storage_unit_movements',
  defaultTtl: '2m',
  hashLargeSegments: true,
  emitMeta: true,
});

// All endpoints are reads (historical movement queries)

export const getAllItemsMovementsByIdAndDateRange = async (localId: number, startDate: string, endDate: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllItemsMovementsByIdAndDateRange/${localId}/${startDate}/${endDate}`));
};

export const getAllIngredientsMovementsByIdAndDateRange = async (localId: number, startDate: string, endDate: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllIngredientsMovementsByIdAndDateRange/${localId}/${startDate}/${endDate}`));
};

export const getAllUtilitiesMovementsByIdAndDateRange = async (localId: number, startDate: string, endDate: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllUtilitiesMovementsByIdAndDateRange/${localId}/${startDate}/${endDate}`));
};

export const getAllProductMovementsByIdAndDateRange = async (productID: string, startDate: string, endDate: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllProductMovementsByIdAndDateRange/${productID}/${startDate}/${endDate}`));
};

export const getAllMovementsByStorageUnitIdAndDateRange = async (storageID: string, startDate: string, endDate: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllMovementsByStorageUnitIdAndDateRange/${storageID}/${startDate}/${endDate}`));
};